export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="31" fill="none" stroke="#C6A87C" strokeWidth="2" opacity="0.6" />
    <path d="M22 24 L26 46 L38 46 L42 24 Z" fill="none" stroke="#C6A87C" strokeWidth="3" strokeLinejoin="round" />
    <path d="M24 30 L40 30" stroke="#C6A87C" strokeWidth="2" opacity="0.55" />
    <path d="M28 18 C26 15 30 13 28 10" stroke="#C6A87C" strokeWidth="2.4" fill="none" strokeLinecap="round" />
    <path d="M35 18 C33 15 37 13 35 10" stroke="#C6A87C" strokeWidth="2.4" fill="none" strokeLinecap="round" opacity="0.7" />
  </svg>
);

const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={compact ? "h-7 w-7" : "h-9 w-9 transition-all duration-500"} />
    <span className="leading-none">
      <span
        className={`font-display block text-gold transition-all duration-500 ${
          compact ? "text-lg" : "text-xl"
        }`}
      >
        TMV Foods
      </span>
      <span className="mt-1 block text-[9px] uppercase tracking-widest2 text-cream/50">
        The Modern Village
      </span>
    </span>
  </span>
);

export default Logo;
